import { gql } from '@apollo/client';
import { BinStatus } from '../types/bin';
import { CreateBinStatusInput, UpdateBinStatusInput, DeleteBinStatusInput } from '../types/bin/binStatus.input';
import { forPaginated } from './common/paginated.graphql';

const binStatus = gql`
  fragment BinStatus on BinStatus {
    id
    version
    companyId
    updatedAt
    updatedBy
    status
    color
    inboundAllowed
    outboundAllowed
  }
`;

const get = gql`
  query BinStatuses($companyId: String!, $page: Float) {
    binStatuses(companyId: $companyId, page: $page) {
      data {
        ...BinStatus
      }
      page
      pageSize
      batchSize
      hasNext
    }
  }
  ${binStatus}
`;

export interface GetBinStatusesVariables {
  companyId: string;
  page?: number;
}

export interface GetBinStatusesResponse {
  binStatuses: PaginatedBinStatuses;
}

class PaginatedBinStatuses extends forPaginated<BinStatus>() {}

const create = gql`
  mutation CreateBinStatus($binStatuses: [CreateBinStatusInput!]!) {
    createBinStatus(binStatuses: $binStatuses) {
      ...BinStatus
    }
  }
  ${binStatus}
`;

export interface CreateBinStatusVariables {
  binStatuses: CreateBinStatusInput[];
}

export interface CreateBinStatusResponse {
  createBinStatus: BinStatus[];
}

const update = gql`
  mutation UpdateBinStatus($binStatuses: [UpdateBinStatusInput!]!) {
    updateBinStatus(binStatuses: $binStatuses) {
      ...BinStatus
    }
  }
  ${binStatus}
`;

export interface UpdateBinStatusVariables {
  binStatuses: UpdateBinStatusInput[];
}

export interface UpdateBinStatusResponse {
  updateBinStatus: BinStatus[];
}

const remove = gql`
  mutation DeleteBinStatus($binStatuses: [DeleteBinStatusInput!]!) {
    deleteBinStatus(binStatuses: $binStatuses) {
      ...BinStatus
    }
  }
  ${binStatus}
`;

export interface DeleteBinStatusVariables {
  binStatuses: DeleteBinStatusInput[];
}

export interface DeleteBinStatusResponse {
  deleteBinStatus: BinStatus[];
}

export const BinStatusQueries = {
  get,
};

export const BinStatusMutations = {
  create,
  update,
  remove,
};

export const BinStatusFragments = {
  binStatus,
};
